export default __webpack_public_path__ + "69eec42669ca68261a67106afb35db86.svg";